import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { InputText } from "primereact/inputtext";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { add } from "lodash";
import colors from "assets/theme/base/colors";
import nodata from "assets/images/nodata.png";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function Department() {
  // Variable Declarations
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [departments, setDepartments] = useState([]);
  const [showAddDepartmentModal, setshowAddDepartmentModal] = useState(false);
  const [showUpdateDepartmentModal, setshowUpdateDepartmentModal] =
    useState(false);
  const [showDeleteDepartmentModal, setshowDeleteDepartmentModal] =
    useState(false);
  const [newDepartment, setNewDepartment] = useState({
    name: "",
    description: "",
  });
  const [error, setError] = useState({ name: "", description: "" });
  const [editDepartment, setEditDepartment] = useState({
    id: "",
    name: "",
    description: "",
  });
  const [editError, setEditError] = useState({ name: "", description: "" });
  const [deleteDepartmentId, setDeleteDepartmentId] = useState(null);

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [searchKeyword, setSearchKeyword] = useState("");

  const [formErrors, setFormErrors] = useState({
    name,
    description,
  });

  const callErrors = (NAME, DESCRIPTION) => {
    const errors = {};
    if (NAME === "") {
      errors.name = " * Department Name is Required";
    }
    if (DESCRIPTION === "") {
      errors.description = " * Department Description is Required";
    }

    setFormErrors(errors);
  };

  // Session Storage Calls
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getDepartments();
    } else {
      let filteredDepartments = departments.filter((dep) => {
        const nameMatch =
          dep.name && dep.name.toLowerCase().includes(searchTerm);
        const descriptionMatch =
          dep.description && dep.description.toLowerCase().includes(searchTerm);

        return nameMatch || descriptionMatch;
      });
      setDepartments(filteredDepartments);
    }
  };

  // GET Api calls
  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data.departments);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setName("");
        setDescription("");
      });
  };

  // Add Functions
  const showDepartmentAddModal = () => {
    setshowAddDepartmentModal(true);
  };
  const handleOkAddDepartmentModal = () => {
    if (name && description) {
      addDepartment();
      setshowAddDepartmentModal(false);
    } else {
      callErrors(name, description);
    }
  };
  const handleCancelAddDepartmentModal = () => {
    setshowAddDepartmentModal(false);
    setDescription("");
    setName("");
    setFormErrors({
      name: "",
      description: "",
    });
  };
  const addDepartment = () => {
    let data = { name, description };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/department/add_department`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getDepartments();
        toast.success("Department Added Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setName("");
        setDescription("");
      });
  };

  // Update Functions
  const showDepartmentUpdateModal = () => {
    if (currentAppId !== (null || undefined)) {
      setshowUpdateDepartmentModal(true);
      getDepartmentbyId();
    }
  };
  const handleOkUpdateDepartmentModal = () => {
    if (name && description) {
      updateDepartment();
      setshowUpdateDepartmentModal(false);
    } else {
      callErrors(name, description);
    }
  };
  const handleCancelUpdateDepartmentModal = () => {
    setshowUpdateDepartmentModal(false);
    setDescription("");
    setName("");
    setFormErrors({
      name: "",
      description: "",
    });
  };

  const getDepartmentbyId = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${BASE_URL}/department/getDepartmentbyId/${currentAppId}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status: ${response.status}`);
        }
        return response.json(); // Convert the response to JSON
      })
      .then((data) => {
        setName(data.department[0].name);
        setDescription(data.department[0].description);
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  };

  const updateDepartment = () => {
    let data = { id: currentAppId, name: name, description: description };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/department/update_department`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getDepartments();
        toast.success("Department Updated Successfully");
      })
      .catch((err) => console.log("err: ", err))
      .finally(() => {
        setName("");
        setDescription("");
      });
  };

  // Delete Functions
  const showDepartmentDeleteModal = () => {
    setshowDeleteDepartmentModal(true);
  };
  const handleOkDeleteDepartmentModal = () => {
    deleteDepartment();
    setshowDeleteDepartmentModal(false);
  };
  const handleCancelDeleteDepartmentModal = () => {
    setshowDeleteDepartmentModal(false);
  };

  const deleteDepartment = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/department/delete_department/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        getDepartments();
        setshowDeleteDepartmentModal(false);
        toast.success("Department Deleted Successfully");
      })
      .catch((error) => console.log(error));
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Department Name", accessor: "department_name", align: "left" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    departments.length > 0
      ? departments.map((dept, index) => ({
          serial: index + 1,
          department_name: dept.name,
          description: dept.description,
          actions: (
            <>
              <div>
                <IconButton
                  aria-label="more"
                  id={`long-button-${index}`}
                  aria-controls={opens ? "long-menu" : undefined}
                  aria-expanded={opens ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={(event) => handleClick(event, dept.id)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={opens}
                  onClose={handleClose}
                >
                  <MenuItem onClick={showDepartmentDeleteModal}>
                    <DeleteIcon style={{ marginRight: "15px", color: "red" }} />{" "}
                    Delete
                  </MenuItem>
                  <MenuItem onClick={showDepartmentUpdateModal}>
                    <EditIcon style={{ marginRight: "15px", color: "green" }} />{" "}
                    Edit
                  </MenuItem>
                </Menu>
              </div>
            </>
          ),
        }))
      : [
          {
            serial: null,
            department_name: null,
            description: null,
            actions: null,
          },
        ];

  // Initial Renderings
  useEffect(() => {
    getDepartments();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              className="mt-5"
              sx={{ boxShadow: "none", border: "1px solid #DADADAEE", borderRadius: "5px" }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "333px",
                        border: "1px solid #8C8C8C",
                        boxShadow: "none",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                        sx={{ color: "gray", width: "22px", height: "22px" }}
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="filled"
                    endIcon={<AddIcon  sx={{width: "22px", height: "22px",  marginLeft: "22px", }} />}
                    onClick={showDepartmentAddModal}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: '40px',
                      width: "120px",
                      fontSize: "16px",
                    }}
                  >
                    Add
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {departments && departments.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        fullScreen={fullScreen}
        open={showAddDepartmentModal}
        onClose={handleCancelAddDepartmentModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Add Department"}
        </DialogTitle>
        <DialogContent>
          <div className="form-outline mt-3">
            <label>Name</label>
            <input
              name="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocus={handleFocus}
              className="form-control form-control-lg"
              placeholder="Enter Name"
            />
          </div>
          <div style={{ color: "red" }}>{formErrors.name}</div>

          <div className="form-outline mt-3">
            <label>Description</label>
            <input
              name="description"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onFocus={handleFocus}
              className="form-control form-control-lg"
              placeholder="Enter Description"
            />
          </div>
          <div style={{ color: "red" }}>{formErrors.description}</div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAddDepartmentModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkAddDepartmentModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showDeleteDepartmentModal}
        onClose={handleCancelDeleteDepartmentModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Delete Department"}
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Department?
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelDeleteDepartmentModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkDeleteDepartmentModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showUpdateDepartmentModal}
        onClose={handleCancelUpdateDepartmentModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Update Department"}
        </DialogTitle>
        <DialogContent>
          <div className="form-outline mt-3">
            <label>Name</label>
            <input
              name="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocus={handleFocus}
              className="form-control form-control-lg"
              placeholder="Enter Name"
            />
          </div>
          <div style={{ color: "red" }}>{formErrors.name}</div>

          <div className="form-outline mt-3">
            <label>Description</label>
            <input
              name="description"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onFocus={handleFocus}
              className="form-control form-control-lg"
              placeholder="Enter Description"
            />
          </div>
          <div style={{ color: "red" }}>{formErrors.description}</div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelUpdateDepartmentModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkUpdateDepartmentModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Department;
